import React from "react";
import { Comment } from "../../shared/components/icons";
import { DialogTitleWithCloseButton, TextField, Tooltip, IconButton, Dialog, DialogContent, DialogContentText, DialogActions, Button }  from "../../shared/components";
import { useForm } from 'react-hook-form';
import { useAuth0 } from "../../auth/AuthContext";
import * as api from "../../shared/api-client";
import { useDispatch } from "react-redux";
import { showError, showSuccess } from "../../store/notifications/actions";
import html2canvas from 'html2canvas';
import { logger } from "../../shared/services/loggingService";

export default function FeedbackWidget(props) {
    const validate = (values: { suggestedTargetAudience: string, positives: string, suggestions: string }) => {
        if (!values.suggestedTargetAudience && !values.positives && !values.suggestions) {
            return { form: "Please answer at least one question." };
        }

        return {};
    };
    const { register, handleSubmit, errors } = useForm({
        resolver: async (values: any) => {
            const errors = validate(values);

            return {
                values,
                errors
            };
        }
    });
    const [open, setOpen] = React.useState(false);
    const [screenshot, setScreenshot] = React.useState(null);
    const { user } = useAuth0();
    const dispatch = useDispatch();

    const openDialog = () => {
        setOpen(true);
    };

    const closeDialog = () => {
        setOpen(false);
    }

    React.useEffect(() => {
        if (!open) return;

        setTimeout(() => {
            try {
                html2canvas(document.body, {
                    foreignObjectRendering: false, ignoreElements: (el) => el?.tagName?.toLowerCase() === "noscript" || el?.className?.indexOf?.("MuiDialog-root") > -1 || el?.className?.indexOf?.("MuiDrawer-root") > -1 || el?.className?.indexOf?.("MuiTooltip-popper") > -1
                }).then(canvas => {
                    const image = canvas.toDataURL("image/png");
                    setScreenshot(image);
                });
            }
            catch (ex) {
                logger?.trackException?.({
                    error: {
                        name: "Failed to capture screenshot",
                        message: ex
                    }
                });
            }
        }, 500);
    }, [open]);

    const submitFeedback = (feedback) => {

        new api.FeedbackClient()
            .create({
                userName: user?.name || "Anonymous User",
                url: window.location.href,
                pageTitle: document.title,
                formData: JSON.stringify(feedback),
                screenshot
            })
            .then(() => {
                closeDialog();
                dispatch(showSuccess("Your feedback has been received.  Thank you!"));
            })
            .catch((error) => dispatch(showError("Failed to submit feedback.  Please try again.")));
    };

    return <>
        <Tooltip title="Submit Feedback About This Report" arrow>
            <IconButton id="btn-feedback" aria-controls="user-menu" aria-haspopup="true" onClick={openDialog}>
                <Comment size="small" />
            </IconButton>
        </Tooltip>

        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason !== 'backdropClick') {
                    closeDialog();
                }
            }}
            aria-labelledby="form-dialog-title">
            <DialogTitleWithCloseButton onClose={closeDialog} id="form-dialog-title">
                Submit Feedback
            </DialogTitleWithCloseButton>
            <form onSubmit={handleSubmit(submitFeedback)}>
                <DialogContent>
                    <DialogContentText>
                        Please submit your feedback and suggestions by answering one or more questions below.
                    </DialogContentText>
                    <br />
                    <br />
                    <div className="vertical-form-field">Who would this report be useful to?</div>
                    <TextField
                        name="suggestedTargetAudience"
                        error={!!errors.suggestedTargetAudience}
                        helperText={errors.suggestedTargetAudience?.message}
                        multiline
                        inputRef={register}
                        autoFocus
                        fullWidth
                    />
                    <div className="vertical-form-field">What is good about this report?</div>
                    <TextField
                        name="positives"
                        error={!!errors.positives}
                        helperText={errors.positives?.message}
                        multiline
                        inputRef={register}
                        fullWidth
                    />
                    <div className="vertical-form-field">What would you like to see improved?</div>
                    <TextField
                        name="suggestions"
                        error={!!errors.suggestions}
                        helperText={errors.suggestions?.message}
                        multiline
                        inputRef={register}
                        fullWidth
                    />
                    {
                        errors.form &&
                        <div className="form-errors">
                            {errors.form}
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained" color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    </>
}